const Books = (object) => {
  const { img, title, author, id, index } = object;
  return (
    <article className="book" data-id={id}>
      <img src={img} alt={title} />
      <h2>{title}</h2>
      <h4>{author}</h4>
      <span className="number">{`#${index + 1}`}</span>
    </article>
  );
};

export default Books;
